/*
 *  ~ Copyright (c) by INFODATA-GROUP. All rights reserved.
 *  ~ No part of this publication may be reproduced, distributed,
 *  ~ or transmitted in any form or by any means, including photocopying, recording,
 *  ~ or other electronic or mechanical methods, without the prior written permission of the publisher,
 *  ~ except in the case of brief quotations embodied in critical
 *  ~ reviews and certain other noncommercial uses permitted by copyright law.
 *  ~ Author : BS
 *  ~ Date : 3/9/23, 5:01 PM
 */

import { Factory } from '@infodata-group/inf-commons';
import { GmapsTheme } from '../model/gmaps-theme';
import { BoGmapsThemeInterface } from '../interface/back-office/bo-gmaps-theme.interface';

export class GmapsThemeFactory implements Factory<GmapsTheme> {
  public build(o: BoGmapsThemeInterface): GmapsTheme {
    const theme = new GmapsTheme(
      o.id,
      o.label,
      o.img,
      JSON.parse(o.mapTypeStyle)
    );
    theme.tags = o.tags;
    return theme;
  }

  public getApi(): string {
    return 'data-gmaps-theme/';
  }
}
